export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5157.c11fd27c.jpg";